import { FilterArrayType } from 'common/components/Filters';

export const toFilterVariableExport = (filterList: FilterArrayType[]) => {
  const keyMapping: { [key: string]: string } = {
    businessUnitId: 'filterBusinessUnitId',
    _createdByUserid: 'filterCreatedById',
    currencyId: 'filterCurrencyId',
    departmentId: 'filterDepartmentId',
    filterMultiStatusTypes: 'filterMultiStatusTypes',
    corporateWorkgroupId: 'filterWorkgroupId',
  };

  const filterVariablesList = filterList.reduce((acc, { filterKey, value }) => {
    const newKey = keyMapping[filterKey];
    if (newKey) {
      acc[newKey] = value;
    } else if (
      filterKey === '_isCorporateTravelAuthorization' &&
      value !== undefined
    )
      acc[value ? 'filterIsCorporateOrigin' : 'filterIsProductionOrigin'] =
        true;
    return acc;
  }, {} as { [key: string]: string | number | boolean | any[] });

  return filterVariablesList;
};
